module.exports = __webpack_public_path__ + "img/both_icon_white.3e73ec6d.svg";